module.exports = "<template>\r\n    <require from=\"./spinner.css\"></require>\r\n\r\n    <div class=\"bulletspinner\">\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n        <div></div>\r\n    </div>\r\n</template>";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/spinner/bullet-spinner.html
// module id = app/components/spinner/bullet-spinner.html
// module chunks = 0